import { render, staticRenderFns } from "./HandicapRetentionData.vue?vue&type=template&id=280c69a5&scoped=true"
import script from "./HandicapRetentionData.vue?vue&type=script&lang=js"
export * from "./HandicapRetentionData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c69a5",
  null
  
)

export default component.exports